import { useState } from 'react';
import { useBotWallet } from './useBotWallet';
import { useManualTrade, TxMsg } from './useManualTrade';

const QUICK    = ['0.01','0.05','0.1','0.25','0.5','1'];
const SELL_PCT = ['10%','25%','33%','50%','75%','100%'];

export default function TrackerTradingPanel({ tokenMint, tokenSymbol }) {
  const [amount,  setAmount]  = useState('0.1');
  const [sellPct, setSellPct] = useState('100%');
  const [slippage,setSlippage]= useState('auto');
  const [jitoTip, setJitoTip] = useState('low');

  const { walletList, activeId, setActiveId, balances, activeKeypair, isSim } = useBotWallet();
  const activeWalletObj = walletList.find(w => w.id === activeId) || walletList[0];
  const vpsWalletId     = activeWalletObj?.fromVPS && !isSim ? activeId : null;
  const effectiveKeypair = isSim ? 'sim' : activeKeypair;

  const { buyLoading, sellLoading, msg, executeBuy, executeSell } = useManualTrade(effectiveKeypair, vpsWalletId);

  if (!tokenMint) return null;

  const canTrade = isSim || vpsWalletId || activeKeypair;

  const btnBase = {
    borderRadius: 5, fontSize: 11, fontWeight: 800, cursor: 'pointer', flexShrink: 0,
    padding: '6px 16px', border: 'none',
  };

  return (
    <div style={{borderTop:'1px solid #1a2030',background:'#090c12',padding:'10px 14px',flexShrink:0}}>

      {/* Message feedback */}
      {msg && <div style={{marginBottom:8}}><TxMsg msg={msg}/></div>}

      <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>

        {/* Sélecteur wallet */}
        <div style={{display:'flex',flexDirection:'column',gap:3,flexShrink:0}}>
          <span style={{fontSize:8,color:'#3a4a5a',letterSpacing:'0.8px'}}>WALLET</span>
          <select
            value={activeId}
            onChange={e => setActiveId(e.target.value)}
            style={{background:'#0d1117',border:'1px solid #1a2030',borderRadius:4,color:'#c0c8d8',fontSize:10,padding:'4px 6px',outline:'none',cursor:'pointer',maxWidth:140}}
          >
            {walletList.map(w => (
              <option key={w.id} value={w.id}>
                {w.isSim ? 'SIM' : w.name} — {(balances[w.id]??0).toFixed(3)} SOL
              </option>
            ))}
          </select>
        </div>

        <div style={{width:1,height:32,background:'#1a2030',flexShrink:0}}/>

        {/* Montants rapides + bouton Acheter */}
        <div style={{display:'flex',flexDirection:'column',gap:4,flex:1,minWidth:200}}>
          <span style={{fontSize:8,color:'#3a4a5a',letterSpacing:'0.8px'}}>ACHETER (SOL)</span>
          <div style={{display:'flex',alignItems:'center',gap:4,flexWrap:'wrap'}}>
            {QUICK.map(q => (
              <button key={q} onClick={() => setAmount(q)}
                style={{padding:'3px 7px',borderRadius:4,fontSize:10,fontWeight:700,cursor:'pointer',
                  background:amount===q?'rgba(0,229,204,0.18)':'#0d1117',
                  border:`1px solid ${amount===q?'#00e5cc44':'#1a2030'}`,
                  color:amount===q?'#00e5cc':'#5a6a80'}}>
                {q}
              </button>
            ))}
            <button
              onClick={() => executeBuy(tokenMint, amount, slippage, jitoTip)}
              disabled={buyLoading || !canTrade}
              style={{...btnBase,
                marginLeft:'auto',
                background: buyLoading ? '#0d1117' : isSim
                  ? 'linear-gradient(135deg,#7c4dff,#5c2dff)'
                  : 'linear-gradient(135deg,#00e5cc,#00b8a0)',
                border: buyLoading ? '1px solid #1a2030' : 'none',
                color: buyLoading ? '#5a6a80' : '#060809',
                opacity: !canTrade ? 0.4 : 1,
                cursor: buyLoading || !canTrade ? 'not-allowed' : 'pointer',
              }}
            >
              {buyLoading ? '⏳...' : isSim ? `Sim ${amount} SOL` : `Acheter ${amount} SOL`}
            </button>
          </div>
        </div>

        <div style={{width:1,height:32,background:'#1a2030',flexShrink:0}}/>

        {/* Pourcentages + bouton Vendre */}
        <div style={{display:'flex',flexDirection:'column',gap:4,flex:1,minWidth:200}}>
          <span style={{fontSize:8,color:'#3a4a5a',letterSpacing:'0.8px'}}>VENDRE</span>
          <div style={{display:'flex',alignItems:'center',gap:4,flexWrap:'wrap'}}>
            {SELL_PCT.map(p => (
              <button key={p} onClick={() => setSellPct(p)}
                style={{padding:'3px 7px',borderRadius:4,fontSize:10,fontWeight:700,cursor:'pointer',
                  background:sellPct===p?'rgba(255,107,107,0.18)':'rgba(255,107,107,0.05)',
                  border:`1px solid ${sellPct===p?'#ff6b6b44':'#ff6b6b22'}`,
                  color:'#ff6b6b'}}>
                {p}
              </button>
            ))}
            <button
              onClick={() => executeSell(tokenMint, sellPct, slippage, jitoTip)}
              disabled={sellLoading || !canTrade}
              style={{...btnBase,
                marginLeft:'auto',
                background: sellLoading ? '#0d1117' : 'linear-gradient(135deg,#ff6b6b,#cc4444)',
                border: sellLoading ? '1px solid #1a2030' : 'none',
                color: sellLoading ? '#5a6a80' : '#fff',
                opacity: !canTrade ? 0.4 : 1,
                cursor: sellLoading || !canTrade ? 'not-allowed' : 'pointer',
              }}
            >
              {sellLoading ? '⏳...' : isSim ? `Sim Vendre ${sellPct}` : `Vendre ${sellPct}`}
            </button>
          </div>
        </div>

        {/* Slippage + Jito */}
        <div style={{display:'flex',flexDirection:'column',gap:4,flexShrink:0}}>
          <span style={{fontSize:8,color:'#3a4a5a',letterSpacing:'0.8px'}}>SLIPPAGE / JITO</span>
          <div style={{display:'flex',gap:4}}>
            <select value={slippage} onChange={e=>setSlippage(e.target.value)}
              style={{background:'#0d1117',border:'1px solid #1a2030',borderRadius:4,color:'#8a9ab0',fontSize:9,padding:'4px',outline:'none',cursor:'pointer'}}>
              <option value="auto">Auto</option>
              <option value="1">1%</option>
              <option value="5">5%</option>
              <option value="10">10%</option>
            </select>
            <select value={jitoTip} onChange={e=>setJitoTip(e.target.value)}
              style={{background:'#0d1117',border:'1px solid #1a2030',borderRadius:4,color:'#8a9ab0',fontSize:9,padding:'4px',outline:'none',cursor:'pointer'}}>
              <option value="low">Low</option>
              <option value="medium">Med</option>
              <option value="high">High</option>
            </select>
          </div>
        </div>

        {/* Indicateur wallet actif */}
        <div style={{fontSize:9,color:isSim?'#7c4dff':vpsWalletId?'#00e5cc':'#5a6a80',
          padding:'3px 8px',borderRadius:4,flexShrink:0,
          background:isSim?'rgba(124,77,255,0.08)':vpsWalletId?'rgba(0,229,204,0.06)':'transparent',
          border:`1px solid ${isSim?'#7c4dff22':vpsWalletId?'#00e5cc22':'transparent'}`}}>
          {isSim ? 'Simulation' : vpsWalletId ? 'VPS Live' : 'Keypair'}
        </div>

      </div>
    </div>
  );
}
